import { dataLayerProvider, gtagProvider, tracker } from '@femtasy/helpers';

import { isProduction } from 'helpers/env';

type Params = Record<string, unknown>;

const getEventParams = () => ({ send_to: 'default' });

const analytics = {
  track: (eventName: string, params: Params) => {
    const gaParams = Object.assign(
      {
        event_category: params.category,
        event_label: params.label,
        value: params.value,
        ...getEventParams(),
      },
      params,
    );

    tracker.sendEvent(eventName, [gaParams], !isProduction(), [gtagProvider, dataLayerProvider]);
  },

  page: (pageName: string, pagePath?: string | Location, params?: Params) => {
    const path =
      typeof pagePath === 'string'
        ? pagePath
        : pagePath?.pathname ?? window.location.pathname;

    tracker.pageView(pageName, path, params, !isProduction(), [gtagProvider]);
  },

  identify: ({
    userId,
    userIdHash,
    subscriptionStatus,
    isTrialer,
  }: {
    userId: string;
    userIdHash: string;
    subscriptionStatus: string;
    isTrialer: string;
  }) => {
    tracker.identify(userIdHash);
    tracker.sendEvent(
      'login',
      [
        {
          user_id: userIdHash,
          subscription_status: subscriptionStatus,
          is_trialer: isTrialer,
        },
      ],
      !isProduction(),
      [dataLayerProvider],
    );
  },

  sendTrackingId: (trackingId: string) => {
    tracker.sendEvent(
      'sign_up',
      [{ user_id: trackingId }],
      !isProduction(),
      [dataLayerProvider]
    );
  },
};

export default analytics;
